const baseTransformParams = 'q_auto,vc_auto,dpr_auto'

const video = (config, sizes) => ({
  sizes,

  injectTransformParams (url, params) {
    return url.replace(`www.datocms-assets.com/${config.datoSpaceId}/`, `${config.cloudinaryUrl}/${params}/dato/`)
  },

  defaultTransform: {
    transform: '16x9_lg',
    sizing: null,
    extraParams: ''
  },

  transform (url, transformOptions) {
    const options = {
      ...this.defaultTransform,
      ...transformOptions
    }
    const { transform, sizing, extraParams } = options

    const extraParamsString = extraParams && extraParams.length ? `,${extraParams}` : ''
    const size = sizing ? `,w_${sizing.w},h_${sizing.h},c_fill` : (transform ? this.sizes[transform] : '')
    const transformString = `${baseTransformParams}${extraParamsString}${size}`
    return this.injectTransformParams(url, transformString)
  }
})

export default ({ $config }, inject) => {
  const sizes = {
    '16x9_sm': ',w_800,h_450,c_fill',
    '16x9_md': ',w_1200,h_975,c_fill',
    '16x9_lg': ',w_1600,h_900,c_fill',
    '4x5_sm': ',w_640,h_800,c_fill',
    '4x5_md': ',w_960,h_1200,c_fill',
    '4x5_lg': ',w_1280,h_1600,c_fill',
    '9x16_sm': ',w_450,h_800,c_fill',
    '9x16_md': ',w_975,h_1200,c_fill',
    '9x16_lg': ',w_900,h_1600,c_fill'
  }

  inject('video', video({
    datoSpaceId: $config.datoSpaceId,
    cloudinaryUrl: $config.cloudinaryUrl
  }, sizes))
}
